import cns from 'classnames'
import { Text } from 'shared/ui/common/Text'
import { Button } from 'shared/ui/controls/Button'

import s from './HeaderNFCSButton.module.scss'

type NFCSButtonProps = {
  icon?: React.ReactNode
  text?: React.ReactNode
  isError?: boolean
  isLoading?: boolean
  className?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export function HeaderNFCSButton({
  icon,
  text,
  onClick,
  isError,
  isLoading,
  className,
}: NFCSButtonProps) {
  return (
    <div
      onClick={onClick}
      className={cns(
        s.wrap,
        isLoading ? s.loadingWrap : s.generateWrap,
        className,
      )}
    >
      <Button
        size={40}
        isSquare
        fashion={isError ? 'error' : 'glass-branded'}
        className={s.generateButton}
        isClickable={Boolean(onClick)}
      >
        {icon}
      </Button>
      <Text
        size={12}
        weight={500}
        isUppercased
        color={isError ? 'error' : 'branded'}
      >
        {text}
      </Text>
    </div>
  )
}
